import styled from "styled-components";

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  padding: 2rem;
  font-family: ${({ theme }) => theme?.fonts?.family || 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif'};
`;

export const ErrorIcon = styled.div`
  font-size: 4rem;
  color: #f9ae17;
  margin-bottom: 1.5rem;
  background: #ffffff;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(32, 59, 52, 0.1);
  border: 3px solid #203b34;

  i {
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
  }
`;

export const ErrorTitle = styled.h1`
  color: #203b34;
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const ErrorMessage = styled.p`
  color: #6c757d;
  font-size: 1.25rem;
  text-align: center;
  margin-bottom: 1.5rem;
  max-width: 600px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

export const ErrorContact = styled.p`
  color: #203b34;
  font-size: 1.1rem;
  text-align: center;
  margin-bottom: 2rem;
  max-width: 500px;
  font-weight: 500;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const ContactButton = styled.button`
  background: linear-gradient(45deg, #203b34, #f9ae17);
  color: #ffffff;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 15px rgba(32, 59, 52, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(32, 59, 52, 0.4);
    background: linear-gradient(45deg, #f9ae17, #203b34);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 4px 15px rgba(32, 59, 52, 0.3);
  }

  @media (max-width: 768px) {
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
  }
`;
